<template>
  <div>
    <div
      class="py-5 flex flex-col md:flex-row justify-between items-center"
    >
      <form @submit.prevent="submitSearch()" class="w-full md:w-auto mb-4 md:mb-0">
        <vs-input
          icon-no-border
          placeholder="Search"
          v-model="searchQuery"
          class="w-full md:w-auto input-square-full"
          icon="icon-search"
          icon-pack="feather"
        />
      </form>
      <vs-button
        @click="$router.push('/org_management/add_sites')"
        class="md:w-auto"
        color="#009FB2"
        >Add Site</vs-button
      >
    </div>

    <vs-table stripe :data="lists">
      <template slot="thead">
        <vs-th @click="toggleSort('id')" class="cursor-pointer">
          <div class="flex items-center justify-center">
            <span>No</span>
          </div>
        </vs-th>
        <vs-th @click="toggleSort('name')" class="text-left cursor-pointer">
          <div class="flex items-center">
            <span>Sites</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('name')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('name', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('name', 'desc')"
              />
            </div>
          </div>
        </vs-th>
        <vs-th @click="toggleSort('codeAuth')" class="text-center cursor-pointer">
          <div class="flex items-center justify-center">
            <span>Code Auth</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('codeAuth')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('codeAuth', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('codeAuth', 'desc')"
              />
            </div>
          </div>
        </vs-th>
        <vs-th @click="toggleSort('ipAddress')" class="text-center cursor-pointer">
          <div class="flex items-center justify-center">
            <span>Servers</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('ipAddress')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('ipAddress', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('ipAddress', 'desc')"
              />
            </div>
          </div>
        </vs-th>
        <vs-th @click="toggleSort('onOff')" class="text-center cursor-pointer">
          <div class="flex items-center justify-center">
            <span>Connected</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('onOff')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('onOff', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('onOff', 'desc')"
              />
            </div>
          </div>
        </vs-th>
        <vs-th class="text-center">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr class="pln-color" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td  :data="indextr">
            {{ (currentPage - 1) * itemsPerPage + indextr + 1 }}
          </vs-td>

          <vs-td class="text-left " :data="tr.name">
            {{ tr.name }}
          </vs-td>

          <vs-td class="text-center " :data="tr.name">
            {{ tr.codeAuth }}
          </vs-td>

          <vs-td class="text-center" :data="tr.name">
            {{ tr.ipAddress }}
          </vs-td>

          <!-- <vs-td class="text-center" :data="tr.ip">
          {{ tr.cameras }}
        </vs-td> -->

          <vs-td class="text-center pln-color" :data="tr.ip">
            {{ tr.onOff == "1" ? "Yes" : "No" }}
          </vs-td>

          <vs-td class="text-center">
            <div class="flex justify-center gap-mini">
              <vs-tooltip text="Edit">
                <a href="" @click.prevent="navigateToEditForm(tr.id)">
                  <feather-icon icon="EditIcon" />
                </a>
              </vs-tooltip>
              <vs-tooltip text="Delete">
                <a href="" @click.prevent="conformDelete(tr.id)">
                  <feather-icon icon="TrashIcon" />
                </a>
              </vs-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
       <div class="flex justify-between mt-4">
      <div class="flex items-center">
        <span class="mr-2">Show data</span>
        <vs-select
          class="items-per-page"
          v-model="itemsPerPage"
          @input="updateItemsPerPage"
        >
          <vs-select-item
            v-for="(option, index) in pageOptions"
            :key="index"
            :value="option.value"
            :text="option.text"
          />
        </vs-select>
      </div>
      <CustomPagination
        :current-page.sync="currentPage"
        :total-pages="totalPages"
        :total-data="totalData"
        @update:currentPage="getSiteLists"
      />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import CustomPagination from "@/components/CustomPagination.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";


library.add(faCaretUp, faCaretDown);

export default {
  components: {
    CustomPagination,
    "font-awesome-icon": FontAwesomeIcon,

  },
  data() {
    return {
      selectedId: "",
      searchQuery: "",
      lists: [],
      itemsPerPage: 10,
      currentPage: 1,
      totalData: 0,
      totalPages: 0,
      sortField: "",
      sortOrder: "asc",
      pageOptions: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      // lists: [
      //   {
      //     "siteId" : 1,
      //     "siteName" : "POS LOGISTIC",
      //     "ipaddress" : "xxx.xx.xx.xxx",
      //     "username" : "adminCCTV",
      //     "password" : "admin",
      //     "servers": 3,
      //     "cameras": 21,
      //     "activationDate": "2022-07-21",
      //     "status": 1
      //   },
      //   {
      //     "siteId" : 2,
      //     "siteName" : "STS - OFFICE",
      //     "ipaddress" : "xxx.xx.xx.xxx",
      //     "username" : "adminCCTV",
      //     "password" : "admin",
      //     "servers": 1,
      //     "cameras": 8,
      //     "activationDate": "2022-07-21",
      //     "status": 1

      //   },
      //   {
      //     "siteId" : 3,
      //     "siteName" : "STS - Enginering",
      //     "ipaddress" : "xxx.xx.xx.xxx",
      //     "username" : "adminCCTV",
      //     "password" : "admin",
      //     "servers": 2,
      //     "cameras": 152,
      //     "activationDate": "2022-05-22",
      //     "status": 1
      //   },
      // ],
    };
  },
  mounted() {
    this.$store.dispatch("saveSiteForm", null);
    this.getSiteLists();
  },
  methods: {
    updateItemsPerPage() {
      this.currentPage = 1;
      this.getSiteLists();
    },
    submitSearch() {
      this.currentPage = 1;
      this.getSiteLists();
    },
    navigateToEditForm(id) {
      this.$store.dispatch("updateCurrentSite", id);

      this.$router.push(`/org_management/update_sites/${id}`);
    },
    getSiteLists() {
      this.$vs.loading();
      const params = {
        search: this.searchQuery,
        page: this.currentPage,
        limit: this.itemsPerPage,
      };

      if (this.sortField) {
        params.sort = `${this.sortField} ${this.sortOrder}`;
      }

      console.log("📦 [getSiteLists] API Params:", params);

      api
        .sites(params)
        .then((result) => result.data)
        .then((data) => {
          console.log("✅ [getSiteLists] Response:", data);
          if (data.status) {
            this.lists = data.data;
            this.totalData = data.totalData;
            this.totalPages = data.maxPage;
            this.$store.dispatch("updateSiteLists", data.data);
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.error("❌ [getSiteLists] Error:", e);
          this.$vs.loading.close();
        });
    },
    toggleSort(field) {
      console.log("🔽 [toggleSort] Clicked field:", field);

      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }

      console.log("🔄 [toggleSort] New sortField:", this.sortField);
      console.log("🔄 [toggleSort] New sortOrder:", this.sortOrder);

      this.getSiteLists();
    },
    getSortClass(field, direction) {
      const isActive = this.sortField === field && this.sortOrder === direction;
      return {
        "sort-icon": true,
        active: isActive,
      };
    },
    conformDelete(id) {
      this.selectedId = id;
      this.$vs.dialog({
        color: "danger",
        title: `Confirm Delete`,
        text: "Are you sure will delete this data?.",
        accept: this.doDelete,
      });
    },
    doDelete() {
      this.$vs.loading();
      api
        .deleteSite({ id: this.selectedId })
        .then((result) => result.data)
        .then((data) => {
          console.log(data);
          this.selectedId = "";

          this.$vs.notify({
            title: "Success",
            text: "Delete data success",
            color: "success",
            position: "top-right",
          });

          this.$vs.loading.close();
        })
        .finally(() => {
          this.getSiteLists();
        })
        .catch((e) => {
          console.log(e);
          this.selectedId = "";

          this.$vs.notify({
            title: "Failed",
            text: "Delete data failed",
            color: "danger",
            position: "top-right",
          });

          this.$vs.loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  margin: 0 5px;
}
.text-center::v-deep .vs-table-text {
  justify-content: center;
}
.text-right::v-deep .vs-table-text {
  justify-content: flex-end;
}
.cursor-pointer {
  cursor: pointer;
}
.sort-icon-group {
  line-height: 0.7;
}
.sort-icon {
  color: white;
  font-size: 12px;
  transition: opacity 0.2s ease;
}
.sort-icon.active {
  opacity: 1;
  color: #009fb2;
}
.items-per-page {
  width: 80px;
}
::v-deep .items-per-page .vs-select {
  width: 100%;
}
</style>
